var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BaseScatterChart',{attrs:{"label-x":'Speed (' + this.currentBike.speedUnits +')',"compute-function":this.computeSpeed}})}
var staticRenderFns = []

export { render, staticRenderFns }